import useMutation from "src/hooks/useMutation";

function useCustomerExport() {
  return useMutation({
    path: "/api/v1/customers/export",
    method: "POST",
  });
}

export default useCustomerExport;
